const isProduction = location.hostname === "www.outletcity.com";
const FAVORITE_BRANDS_TOGGLE_STATE_DIMENSION = isProduction ? "dimension39" : "dimension10";

export const setFavoriteBrandsToggleState = (state) => {
	window.ocm.storage.setSessionStorage("favoriteBrandsToggleState", state ? "on" : "off");
};

export const getFavoriteBrandsToggleDimension = () => {
	const state = window.ocm.storage.getSessionStorage("favoriteBrandsToggleState") ?? "off";
	return {
		[FAVORITE_BRANDS_TOGGLE_STATE_DIMENSION]: `meineMarken_${state}`,
	};
};
